import axios from "axios";

// const backend_endpoint = process.env.REACT_APP_BACK_END_ENDPOINT !== undefined ? process.env.REACT_APP_BACK_END_ENDPOINT : 'https://wapi-#{CLIENTNAME}##{INSTANCE}#-sdinsight.azurewebsites.net';
const backend_endpoint = process.env.REACT_APP_BACK_END_ENDPOINT ?? '';

console.log('Configured backend endpoint is for prompt api is ' + backend_endpoint);

export async function getPrompts(accessToken) {

    try {
        // const result = await axios.get(backend_endpoint + '/prompts/tjx');
            const endpoint = backend_endpoint ? `${backend_endpoint}/api/prompts/tjx` : '/api/prompts/tjx';
            const result = await axios.get(endpoint, { 
                headers: { 
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type':'application/json'
                }
            });
        // console.log(result);
        return { prompts : result.data };
        
    } catch (error) {
        console.error('Failed getting prompts \n' + error);
        return {prompts : null, error : error}
    }
};

export function getMasterAuditPrompts() {

    return `Speaker 1 is the Agent and Speaker 2 is the user.
  Analyze the call log transcription below using the criteria listed below.
  
  {
     "criteria": [
         {
             "name": "Call Open and Closing",
             "definition": "Did the analyst use the scripts while opening and closing the call?",
             "examples": "\\"Welcome to XXX IT help desk, This is <User's name>, May I have your first and last name please?\\"\\n\\n\\"Hi <Customer's Name>, How May I help you?\\"\\n\\n\\"Thank you for calling XXX IT helpdesk, Have a great day\\"",
             "score": "8%"
         },
         {
             "name": "Active listening & Acknowledgement",
             "definition": "Did the analyst pay attention to the user and acknowledge appropriately? Was proper response provided in scenarios where the user asks for the time of resolution.",
             "examples": "An Example of not demonstrating active listening:\\n\\nAgent: \\"May I know your first and last name?\\"\\n\\nUser : \\"Barbadoss Cunningham\\"\\n\\nAgent : \\" I'm sorry could you repeat that\\" (twice) \\n\\nUser : B-A-R-B-A-D-O-S-S \\n\\nAnalyst : \\"B - A- R - D- A -B -O-S?\\"\\n\\n\\nThe Analyst should never say \\"I don't know\\" - a proper response when asked for the time of resolution could be (when the analyst is not aware of it):\\n1. \\"Let me check with my team\\" - and then provide the exact duration\\nor\\n2. \\"Lauren, As another team would be working on this, we wouldn't be able to give you the exact duration, however stay assured, the team will work on your issue and get back to you at the earliest\\"",
             "score": "8%"
         },
         {
             "name": "Comprehension",
             "definition": "Did the analyst pay attention to the user and acknowledge appropriately? Was proper response provided in scenarios where the user asks for the time of resolution.",
             "examples": "\\"If I've Understood you correctly, you've tried switching your system ON but your screen remains to be switched off, Am I correct?\\"",
             "score": "8%"
         },
         {
             "name": "Clarity of Communication",
             "definition": "Was the analyst clear in his speech, easy to understand, conveying the information right?",
             "examples": "\\"Stella, when you switch ON the CPU , Do you hear the machine starting up?\\"\\nUser : Yes\\n\\"and do you see a power light on the bottom right corner of your monitor?\\"\\nUser : No\\n\\"Stella, not to worry, this could be due to a poor cable connection, Could you  unplug the monitor cable, replug it and then try to switch ON your computer again?\\"",
             "score": "6%"
         },
         {
             "name": "Empathy, Assurance, Ownership",
             "definition": "Did the analyst exhibit empathy, assurance or ownership wherever required?",
             "examples": "Assurance :\\n\\"Don't worry Stella, I'll surely help you with this\\"\\n\\nEmpathy :\\n(on calls when required) - \\"I'm sorry to hear that Stella, I'll do everything I possibly can to help you with this.\\"\\n\\"I completely understand what you are going through Stella, Don't worry, I'll help you with this.\\"",
             "score": "8%"
         },
         {
             "name": "Personalization",
             "definition": "Did the analyst personalize the call by using the user's name, build rapport when provided an opportunity?",
             "examples": "\\"How's your day going?\\", \\"Let me know if there's anything else I can do.\\"",
             "score": "6%"
         },
         {
             "name": "Hold & Transfer procedure",
             "definition": "Did analyst ask permission to place the user on hold?,  Did analyst explain the reason for hold to the user?, Did analyst check back with user every 120-sec. of hold time?, Did analyst thank the user for holding?, Did the analyst use hold procedure and not mute?, Did the analyst follow proper transfer procedure?",
             "examples": "\\"May I place your call on hold for 2 minutes while I work on this?\\"\\n\\nAfter the hold:\\n\\n\\"Thank you for waiting Stella.\\"",
             "score": "6%"
         },
         {
             "name": "Call control",
             "definition": "Did the analyst exhibit call control - Took ownership of user's concerns, did not make the user repeat by taking notes, avoided interruptions, avoid dead air, avoid long hold or too many holds which impacts the control of the call",
             "examples": "Managing Dead air:\\n\\nExample statements: \\"Stella, please give me a moment, while I work on this.\\"\\n(The Analyst comes back to the user in 30s)\\n\\nOther ways to manage dead air:\\n1. Educate the user with the steps \\n2. Initiate small talk\\n3. Use Hold/mute process",
             "score": "6%"
         },
         {
             "name": "Further Assistance",
             "definition": "Did the analyst offer further assistance?",
             "examples": "Example : \\"Is there anything else I may help you with?\\"",
             "score": "6%"
         },
         {
             "name": "Professionalism",
             "definition": "Was the analyst polite to the customer exhibiting a polite tone and were the choice of words professional?",
             "examples": "\\"Could you please read out the error message for me?\\" instead of \\"and what does the error message say?\\"",
             "score": "8%"
         },
         {
             "name": "Verify or Update User's Account details",
             "definition": "Were the user details like name, user id, call back number, request id etc.. captured before getting into the issue?",
             "examples": "\\"May I know your first and last name?\\"; \\"May I also have your User ID?\\"; \\"And your call back number would be?\\"",
             "score": "6%"
         },
         {
             "name": "Capture the nature of the incident (New or existing)",
             "definition": "Is the issue being reported for the first time or is there an existing ticket?",
             "examples": "\\"Here is your ticket number, <number>\\"; \\"Would you like your ticket number?\\"; \\"Do you need your ticket number?\\"",
             "score": "8%"
         },
         {
             "name": "Customer Education",
             "definition": "Was user education provided wherever required?",
             "examples": "",
             "score": "8%"
         },
         {
             "name": "Ticket number provided",
             "definition": "Was the ticket number provided or offered to the user?",
             "examples": "The agent should provide a ticket number of the call to the user or asked the user if they wanted a ticket number.",
             "score": "8%"
         }
     ]
  }
  
  For each criteria, output the analysis of the call using the following format,
  key="name", value="<name of the criteria>"
  key="response", value="<yes if agent met the criteria, no if the agent did not meet the criteria>"
  key="score", value="<0% for no, score value for yes>"
  key="reason", value="<explain why you choose the response value in one or two points>"
  
  Using the whole call, output the following,
  key="issue", value="<What was the user's issue.>"
  key="feedback", value="<Provide an overall feedback how the call was performed.>"
  
  Separate each row with |. Separate issue and feedback with |`;
  };